import { render, staticRenderFns } from "./IconLogout.vue?vue&type=template&id=e6540d40&scoped=true"
import script from "./IconLogout.vue?vue&type=script&lang=js"
export * from "./IconLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6540d40",
  null
  
)

export default component.exports